import React, { useState, useRef, useContext, useEffect, useMemo } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';
import { Accordion, Card, Button, Modal } from 'react-bootstrap';
import { MultiSelect } from 'react-multi-select-component';
import { useTranslation } from 'react-i18next';
import noImage from '../../../../../assets/images/no-image.png';
import Gradings from './Gradings';
import ImgDropzone from '../../../../../Components/ImgDropzone/ImgDropzone';
import { uploadSuggestionImage, unlinkUploadImage } from '../../../store/SupplierSuggestion.action';
import { MeasurementDataProvider } from '../MeasurementForm';
import Loader from '../../../../../Components/Utility/Loader/Loader';
import { imageUrl } from '../../../../../Components/helper';

function SpecPomLibraries({
  isExisting,
  productRefFromReducer,
  savedUploadedImage,
  delateUploadedImage,
  checkAccodionActiveState,
  handleClickToggle,
  loading,
}) {
  const { sugFracData, onSelectSpecPomLib } = useContext(MeasurementDataProvider);
  const dispatch = useDispatch();
  const {
    control,
    register,
    errors,
    pomLibrariesFields,
    specPomLibrariesFields,
    specPomLibrarieRemove,
    specPomUpdateLibraries,
    setValue,
    getValues,
    reset,
    productRef,
    disabledSubmitButton,
    suggestionEditMode,
    origanalMeasurmentData,
  } = useFormContext();

  useFieldArray({
    control,
    name: 'specPomLibraries',
  });

  let productRefData = null;
  if (productRef[0]?.value) {
    productRefData = productRefFromReducer?.filter((el) => el._id === productRef[0].value)[0];
  }

  const [showImageUpload, setImgUpload] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [fullImage, setFullImage] = useState(noImage);
  const [imageEditMode, setImageEditMode] = useState(false);
  const { t } = useTranslation('common');

  const childRef = useRef();
  const [specPomLibariesDataForMultiSelect, setSpecPomLibariesDataForMultiSelect] = useState([]);

  const [selectedSpecPomLibArray, setSelectedSpecPomLibArray] = useState([]);
  useEffect(() => {
    // Clear POM selection and table data when productRef is cleared
    if (!productRef?.[0]) {
      setValue('specPomLib', [], {
        shouldValidate: true,
      });
      setSelectedSpecPomLibArray([]);
      setSpecPomLibariesDataForMultiSelect([]);
      reset({
        specPomLibraries: [],
      });
      return;
    }

    setValue('specPomLib', [], {
      shouldValidate: true,
    });
    setSelectedSpecPomLibArray([]);
    const dropDownValues = [];
    if (sugFracData?.specPomLibraries && sugFracData?.specPomLibraries.length > 0) {
      sugFracData.specPomLibraries.forEach((item) => {
        dropDownValues.push({
          label: item.code,
          value: item?.code,
        });
      });
    }
    if (suggestionEditMode) {
      setSelectedSpecPomLibArray(dropDownValues);
    }
    disabledSubmitButton(!((specPomLibrariesFields.length === 0 || specPomLibrariesFields.length === 1) && pomLibrariesFields.length > 0));
    setSpecPomLibariesDataForMultiSelect(dropDownValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sugFracData, productRef]);

  const handleImageUpload = async (type) => {
    if (type !== 'close') {
      const { fileObj, originalFileObj } = await childRef.current.showCroppedImg();

      const formData = new FormData();
      formData.append('image', fileObj);
      formData.append('fullImage', originalFileObj);

      const res = await dispatch(uploadSuggestionImage(formData));
      console.log('🚀 ~ handleImageUpload ~ res:', res);

      if (res?.image) {
        setValue(`specPomLibraries[${currentIndex}].img`, res.image, {
          shouldValidate: true,
        });
        setValue(`specPomLibraries[${currentIndex}].fullImage`, res.fullImage, {
          shouldValidate: false,
        });

        specPomLibrariesFields[currentIndex].img = res?.image;
        specPomLibrariesFields[currentIndex].fullImage = res.fullImage;

        await specPomUpdateLibraries(currentIndex, {
          ...specPomLibrariesFields[currentIndex],
        });
        setFullImage(res.fullImage);
        setImgUpload(false);
        savedUploadedImage(res);
        setImageEditMode(true);
      }
    } else {
      setImgUpload(false);
    }
  };

  const showImageUploadModal = (i, fullImg) => {
    setFullImage(fullImg);
    setCurrentIndex(i);
    setImgUpload(true);
  };
  function getImageValue(i, data, imgPath) {
    const imgValue = getValues(`specPomLibraries[${i}].img`);
    const dataImage = data?.image;
    if (imgValue) return `${imgPath}`;
    if (dataImage) return `${dataImage}`;
    return noImage;
  }

  function getFullImageValue(i, data) {
    const fullImageValue = getValues(`specPomLibraries[${i}].fullImage`);
    const dataFullImage = data?.fullImage;
    const dataImage = data?.image;
    if (fullImageValue) return fullImageValue;
    if (dataFullImage) return `${dataFullImage}`;
    if (dataImage) return `${dataImage}`;
    return null;
  }

  const removeSuggestionImage = async (index) => {
    const imageArray = [];
    imageArray.push(getValues(`specPomLibraries[${index}].img`), getValues(`specPomLibraries[${index}].fullImage`));

    const res = await unlinkUploadImage({ images: imageArray });
    if (res) {
      setValue(`specPomLibraries[${index}].img`, undefined, {
        shouldValidate: true,
      });
      setValue(`specPomLibraries[${index}].fullImage`, undefined, {
        shouldValidate: false,
      });

      specPomLibrariesFields[currentIndex].img = res.image;
      specPomLibrariesFields[currentIndex].fullImage = res.fullImage;
      await specPomUpdateLibraries(currentIndex, {
        ...specPomLibrariesFields[currentIndex],
      });

      delateUploadedImage(imageArray);
      setImageEditMode(false);
    }
  };
  const onSelectPomLibarie = (val) => {
    setValue('specPomLib', val, {
      shouldValidate: true,
    });
    setSelectedSpecPomLibArray(val);

    if (val.length === specPomLibariesDataForMultiSelect.length) {
      onSelectSpecPomLib('selectAll');
    } else if (val.length) {
      onSelectSpecPomLib(val, selectedSpecPomLibArray);
    } else {
      onSelectSpecPomLib('deSelectAll');
    }
    disabledSubmitButton(!(pomLibrariesFields.length > 0 || val.length > 0));
  };

  const removeSpecPomLib = async (data) => {
    const removeLib = await specPomLibrariesFields.filter((elem) => elem.code === data.code);
    const index = await specPomLibrariesFields.findIndex((pomField) => removeLib[0].code === pomField.code);
    await setSelectedSpecPomLibArray((prev) => prev.filter((el) => el.label !== data.code));
    await specPomLibrarieRemove(index);
    disabledSubmitButton(!((specPomLibrariesFields.length === 0 || specPomLibrariesFields.length === 1) && pomLibrariesFields.length > 0));
  };

  const sizeRanges = useMemo(() => {
    const sizesArr = [];
    if (productRefData?.sizeRanges) {
      origanalMeasurmentData[0]?.sizeRanges?.forEach((item) => {
        if (productRefData.sizeRanges.includes(item)) {
          sizesArr.push(item);
        }
      });
    }
    return sizesArr;
  }, [origanalMeasurmentData, productRefData]);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue.split('.')[1]?.length > 3) {
      e.preventDefault(); // Prevent further input
      e.target.value = e.target.value.slice(0, -1); // Remove the last character
    }
  };

  return (
    <>
      <Card className="mb-3 overflow-visible">
        <Card.Header className="overflow-visible py-1">
          <div className="d-flex justify-content-between flex-wrap align-items-center w-100">
            <div className="py-2 py-md-0">{t('SPEC_POM_LIBRARIES.OTHER_SPECIFICATION')}</div>
            <div className="break" />
            <div className="d-flex w-xs-100 code-dropdown  ml-md-auto">
              <div className="mr-md-4 w-200px">
                <MultiSelect
                  disabled={suggestionEditMode}
                  name="specPomLib"
                  {...register('specPomLib', {
                    required: false,
                  })}
                  options={specPomLibariesDataForMultiSelect || []}
                  className="product-custom-multiselect common-new-multiselect w-100"
                  value={selectedSpecPomLibArray}
                  onChange={(val) => {
                    onSelectPomLibarie(val);
                  }}
                  labelledBy={t('SPEC_POM_LIBRARIES.SELECT_SUPLIER')}
                />
              </div>
              <Accordion.Toggle
                className="btn-toggle"
                as={Button}
                variant="link"
                eventKey={checkAccodionActiveState('otherFile')}
                onClick={() => handleClickToggle('otherFile')}
              >
                <i className={checkAccodionActiveState('otherFile') ? 'icon-new-down-arrow-icon inverse' : 'icon-new-down-arrow-icon'} />
              </Accordion.Toggle>
            </div>
          </div>
        </Card.Header>

        <Accordion.Collapse eventKey={checkAccodionActiveState('otherFile')}>
          <Card.Body>
            <div className="table-responsive">
              <table className="table common-custom-table">
                <thead>
                  <tr>
                    <th className="w-100px">{t('SPEC_POM_LIBRARIES.IMAGE')}</th>
                    <th className="w-150px">{t('SPEC_POM_LIBRARIES.POM_CODE')}</th>
                    <th className="w-300px">{t('SPEC_POM_LIBRARIES.POM_DESCRIPTION')}</th>
                    {productRefData &&
                      sizeRanges?.map((dataGrading, i) => {
                        return (
                          <th key={i} className="w-80px text-center">
                            {dataGrading}
                          </th>
                        );
                      })}
                    <th className="w-100px">{t('SPEC_POM_LIBRARIES.TOL')}</th>
                    {!suggestionEditMode && <th className="w-80px">{t('SPEC_POM_LIBRARIES.ACTION')}</th>}
                  </tr>
                </thead>

                <tbody>
                  {specPomLibrariesFields &&
                    specPomLibrariesFields.length > 0 &&
                    specPomLibrariesFields.map((data, i) => {
                      const imgPath = getValues(`specPomLibraries[${i}].img`);

                      return (
                        <tr key={i} className={data.status === 'Approved' || data.status === 'Deleted' ? 'disabled' : ''}>
                          <td style={{ width: '11%' }}>
                            <div className="image-container d-flex align-items-center">
                              <figure className="header-img mb-0">
                                <img
                                  width="48"
                                  name={`specPomLibraries[${i}].img`}
                                  {...register(`specPomLibraries[${i}].img`, {
                                    required: false,
                                  })}
                                  src={getImageValue(i, data, imgPath)}
                                  alt=""
                                />
                                <img
                                  width="0"
                                  name={`specPomLibraries[${i}].fullImage`}
                                  {...register(`specPomLibraries[${i}].fullImage`, {
                                    required: false,
                                  })}
                                  src={() => {
                                    const fullImageValue = getValues(`specPomLibraries[${i}].fullImage`);
                                    const dataFullImage = data?.fullImage;
                                    const dataImage = data?.image;
                                    if (fullImageValue) {
                                      return `${imageUrl}/${imgPath}`;
                                    }
                                    if (dataFullImage) {
                                      return `${imageUrl}/${dataFullImage}`;
                                    }
                                    if (dataImage) {
                                      return `${imageUrl}/${dataImage}`;
                                    }
                                    return noImage;
                                  }}
                                  alt="full_image"
                                  className="d-none"
                                />
                              </figure>

                              <div className="d-flex flex-column">
                                <button className="btn btn-upload-img" type="button" onClick={() => showImageUploadModal(i, getFullImageValue(i, data))}>
                                  <span className="icon-upload" aria-hidden="true" title={t('SPEC_POM_LIBRARIES.UPLOAD_IMAGE')}>
                                    {' '}
                                  </span>
                                </button>
                                {imgPath !== undefined && (
                                  <button className="btn btn-upload-img" type="button" onClick={() => removeSuggestionImage(i)}>
                                    <span className="icon-delete" aria-hidden="true" title={t('SPEC_POM_LIBRARIES.DELETE_IMAGE')}>
                                      {' '}
                                    </span>
                                  </button>
                                )}
                              </div>
                            </div>
                          </td>
                          <td>{data.code}</td>
                          <td>
                            <div className="common-input-control mb-0">
                              <input
                                type="text"
                                style={{ maxWidth: '100% ' }}
                                className="form-control grading-text text-left"
                                name={`specPomLibraries[${i}].description`}
                                {...register(`specPomLibraries[${i}].description`, {
                                  required: false,
                                })}
                                defaultValue={data.description}
                                placeholder={t('SPEC_POM_LIBRARIES.DESCRIPTION')}
                              />
                            </div>
                          </td>

                          <Gradings
                            productRefData={productRefData}
                            isExistingState={isExisting}
                            nestIndex={i}
                            SPECData={data}
                            {...{ control, register, setValue, errors }}
                          />

                          <td>
                            <div className="common-input-control mb-0">
                              <input
                                type="text"
                                style={{ maxWidth: '100% ' }}
                                className="form-control grading-text"
                                name={`specPomLibraries[${i}].tolMinus`}
                                {...register(`specPomLibraries[${i}].tolMinus`, {
                                  required: false,
                                })}
                                defaultValue={data.tolMinus}
                                placeholder={t('SPEC_POM_LIBRARIES.TOL')}
                                onChange={handleInputChange}
                              />
                            </div>
                          </td>
                          {!suggestionEditMode && (
                            <td className="text-center">
                              <button
                                className="border-0 btn-lelete-lib"
                                disabled={specPomLibrariesFields?.length === 1}
                                onClick={() => {
                                  removeSpecPomLib(data);
                                }}
                                aria-label="Delete"
                                type="button"
                              >
                                <span className="icon-delete" />
                              </button>
                            </td>
                          )}
                        </tr>
                      );
                    })}

                  {loading && (
                    <td colSpan={productRefData.sizeRanges.length + 4}>
                      <Loader />
                    </td>
                  )}
                </tbody>
              </table>
            </div>
          </Card.Body>
        </Accordion.Collapse>
      </Card>

      {showImageUpload && (
        <Modal className="common-custom-modal modal-large" show={showImageUpload} backdrop="static">
          <Modal.Header>
            <Modal.Title className="f-24">{t('SPEC_POM_LIBRARIES.UPLOAD_IMAGE')}</Modal.Title>
            <span onClick={() => handleImageUpload('close')} className="icon-close cursor-pointer text-dark text-decoration-none" />
          </Modal.Header>

          <Modal.Body>
            <div className="modal-body">
              <ImgDropzone
                ref={childRef}
                onSubmit={handleImageUpload}
                acceptedFileExtenstion=".jpeg,.png,.jpg"
                image={fullImage}
                isEditMode={imageEditMode}
                title={t('SPEC_POM_LIBRARIES.POM')}
              />
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}

const mapStateToProps = ({ UserDetails, SupplierSuggestion }) => {
  const { productRef } = SupplierSuggestion;
  const { userInfo } = UserDetails;
  return {
    userInfo,
    productRefFromReducer: productRef,
  };
};
const mapStateToDispatch = { uploadSuggestionImage, unlinkUploadImage };

export default connect(mapStateToProps, mapStateToDispatch)(SpecPomLibraries);
